import React, { useState } from 'react';
import { Modal } from './ui/Modal';
function PrivacyContent() {
  return <div className="space-y-6 text-base" data-id="element-81">
      <p className="text-sm text-warmBrown-500 italic" data-id="element-82">
        Última actualización: febrero 2026
      </p>

      <div data-id="element-83">
        <h4 className="text-lg font-bold font-heading text-terracotta mb-2" data-id="element-84">
          1. Información que Recopilamos
        </h4>
        <p data-id="element-85">
          Recopilamos únicamente la información necesaria para procesar tu
          compra y entregarte el producto digital: nombre, dirección de correo
          electrónico y datos de pago. No almacenamos información de tarjetas de
          crédito directamente; los pagos son procesados de forma segura por
          nuestro proveedor de pagos.
        </p>
      </div>

      <div data-id="element-86">
        <h4 className="text-lg font-bold font-heading text-terracotta mb-2" data-id="element-87">
          2. Uso de la Información
        </h4>
        <p data-id="element-88">Tu información personal se utiliza exclusivamente para:</p>
        <ul className="list-disc pl-6 mt-2 space-y-1" data-id="element-89">
          <li data-id="element-90">Procesar y entregar tu compra.</li>
          <li data-id="element-91">
            Enviarte el acceso al material adquirido por correo electrónico.
          </li>
          <li data-id="element-92">
            Comunicarnos contigo sobre actualizaciones relacionadas con tu
            compra.
          </li>
        </ul>
      </div>

      <div data-id="element-93">
        <h4 className="text-lg font-bold font-heading text-terracotta mb-2" data-id="element-94">
          3. Protección de Datos
        </h4>
        <p data-id="element-95">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger tu información personal contra acceso no autorizado, pérdida
          o alteración.
        </p>
      </div>

      <div data-id="element-96">
        <h4 className="text-lg font-bold font-heading text-terracotta mb-2" data-id="element-97">
          4. Compartir Información
        </h4>
        <p data-id="element-98">
          No vendemos, intercambiamos ni transferimos tu información personal a
          terceros, excepto a los proveedores de servicios necesarios para
          procesar tu compra (procesador de pagos, servicio de correo
          electrónico).
        </p>
      </div>

      <div data-id="element-99">
        <h4 className="text-lg font-bold font-heading text-terracotta mb-2" data-id="element-100">
          5. Cookies
        </h4>
        <p data-id="element-101">
          Utilizamos cookies esenciales para el funcionamiento del sitio y
          cookies analíticas para mejorar tu experiencia. Puedes desactivar las
          cookies en la configuración de tu navegador.
        </p>
      </div>

      <div data-id="element-102">
        <h4 className="text-lg font-bold font-heading text-terracotta mb-2" data-id="element-103">
          6. Tus Derechos
        </h4>
        <p data-id="element-104">
          Tienes derecho a acceder, corregir o eliminar tu información personal
          en cualquier momento. Para ejercer estos derechos, contáctanos a
          través de los canales proporcionados en tu correo de confirmación de
          compra.
        </p>
      </div>
    </div>;
}
function TermsContent() {
  return <div className="space-y-6 text-base" data-id="element-105">
      <p className="text-sm text-warmBrown-500 italic" data-id="element-106">
        Última actualización: febrero 2026
      </p>

      <div data-id="element-107">
        <h4 className="text-lg font-bold font-heading text-terracotta mb-2" data-id="element-108">
          1. Aceptación de los Términos
        </h4>
        <p data-id="element-109">
          Al realizar tu compra en Crianza Neuro-Calma, aceptas estos términos y
          condiciones en su totalidad. Si no estás de acuerdo con alguno de
          estos términos, te pedimos que no realices la compra.
        </p>
      </div>

      <div data-id="element-110">
        <h4 className="text-lg font-bold font-heading text-terracotta mb-2" data-id="element-111">
          2. Producto Digital
        </h4>
        <p data-id="element-112">
          Crianza Neuro-Calma es un producto digital educativo. Al completar tu
          compra, recibirás acceso inmediato al material a través de correo
          electrónico. El contenido es para uso personal y no puede ser
          redistribuido, copiado o compartido sin autorización.
        </p>
      </div>

      <div data-id="element-113">
        <h4 className="text-lg font-bold font-heading text-terracotta mb-2" data-id="element-114">
          3. Uso del Material
        </h4>
        <p data-id="element-115">
          El material proporcionado tiene fines educativos e informativos. No
          sustituye el consejo médico, psicológico o terapéutico profesional. Si
          tu hijo o tu familia necesitan atención profesional, te recomendamos
          consultar con un especialista.
        </p>
      </div>

      <div data-id="element-116">
        <h4 className="text-lg font-bold font-heading text-terracotta mb-2" data-id="element-117">
          4. Política de Reembolso
        </h4>
        <p data-id="element-118">
          Debido a la naturaleza digital del producto y su entrega inmediata,
          todas las ventas son finales. Sin embargo, si experimentas problemas
          técnicos para acceder al material, nos comprometemos a resolverlos.
        </p>
      </div>

      <div data-id="element-119">
        <h4 className="text-lg font-bold font-heading text-terracotta mb-2" data-id="element-120">
          5. Propiedad Intelectual
        </h4>
        <p data-id="element-121">
          Todo el contenido de Crianza Neuro-Calma, incluyendo textos, gráficos,
          hojas de trabajo y metodologías, está protegido por derechos de autor.
          Queda prohibida su reproducción total o parcial sin consentimiento
          previo por escrito.
        </p>
      </div>

      <div data-id="element-122">
        <h4 className="text-lg font-bold font-heading text-terracotta mb-2" data-id="element-123">
          6. Limitación de Responsabilidad
        </h4>
        <p data-id="element-124">
          Los resultados pueden variar según cada familia y situación. Crianza
          Neuro-Calma no garantiza resultados específicos, ya que estos dependen
          de la aplicación individual del material.
        </p>
      </div>

      <div data-id="element-125">
        <h4 className="text-lg font-bold font-heading text-terracotta mb-2" data-id="element-126">
          7. Modificaciones
        </h4>
        <p data-id="element-127">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones serán efectivas desde su publicación en
          esta página.
        </p>
      </div>
    </div>;
}
export function Footer() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  return <>
      <footer className="py-8 bg-cream-100 border-t border-cream-200" data-id="element-128">
        <div className="max-w-4xl mx-auto px-4 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-129">
          <p className="text-warmBrown-500 text-sm" data-id="element-130">
            © {new Date().getFullYear()} Crianza Neuro-Calma. Todos los
            derechos reservados.
          </p>
          <div className="flex items-center gap-6" data-id="element-131">
            <button onClick={() => setPrivacyOpen(true)} className="text-sm text-warmBrown-500 hover:text-terracotta transition-colors underline underline-offset-2" data-id="element-132">
              Política de Privacidad
            </button>
            <button onClick={() => setTermsOpen(true)} className="text-sm text-warmBrown-500 hover:text-terracotta transition-colors underline underline-offset-2" data-id="element-133">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      <Modal isOpen={privacyOpen} onClose={() => setPrivacyOpen(false)} title="Política de Privacidad" data-id="element-134">
        <PrivacyContent data-id="element-135" />
      </Modal>

      <Modal isOpen={termsOpen} onClose={() => setTermsOpen(false)} title="Términos y Condiciones" data-id="element-136">
        <TermsContent data-id="element-137" />
      </Modal>
    </>;
}